import { render, staticRenderFns } from "./CopyItemsToOtherMenuModal.vue?vue&type=template&id=307b7d7e&scoped=true&"
import script from "./CopyItemsToOtherMenuModal.vue?vue&type=script&lang=js&"
export * from "./CopyItemsToOtherMenuModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyItemsToOtherMenuModal.vue?vue&type=style&index=0&id=307b7d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b7d7e",
  null
  
)

export default component.exports